import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { UserInfoProvider } from './context/user-info';
import i18n from './i18n';
import { DataProvider } from './context/data.provider';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <QueryClientProvider client={queryClient}>
    <DataProvider>
      <I18nextProvider i18n={i18n}>
        <UserInfoProvider>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </UserInfoProvider>
      </I18nextProvider>
    </DataProvider>
  </QueryClientProvider>,
);
